import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { EntityReference } from '../../../core/entities/shared/entity-reference.entity';
import { fieldIsRequired } from '../../utils/forms.utils';

@Component({
  selector: 'app-entity-reference-input',
  templateUrl: './entity-reference-input.component.html',
  styleUrl: './entity-reference-input.component.scss',
})
export class EntityReferenceInputComponent {
  @Input({ required: true }) control!: FormControl<EntityReference | null>;
  @Input({ required: true }) label!: string;
  @Input({ required: true }) options!: EntityReference[];

  isRequired = fieldIsRequired;
}
